import HireSummary from "@/components/HireSummary";

export default function HireDashboard() {
  return (
    <div className="p-6 sm:p-8 max-w-7xl mx-auto" data-testid="hire-dashboard">
      <div className="mb-8">
        <h1 className="font-heading text-4xl font-black tracking-tighter text-brand-display mt-1">
          Hire Dashboard
        </h1>
      </div>
      <HireSummary showExport showFilters showOwners />
    </div>
  );
}
